import { whiteColor, grayColor } from 'assets/jss/material-dashboard-pro-react';

const summaryTabStyle = (theme) => ({
	smallTab: {
		width: '60%',
		margin: '0 auto',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	summaryTab: {
		marginTop: '24px',
		minHeight: '553px',
		backgroundColor: whiteColor,
		borderRadius: '8px',
	},
	summaryTabWithProgressBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	headingWrapper: {
		padding: '24px 32px 32px 24px',
	},
	summaryTabContainer: {
		maxWidth: '340px',
		width: '80%',
		backgroundColor: grayColor[3],
		margin: '0px auto',
		padding: '16px',
	},
	summaryLine: {
		margin: '16px auto 16px',
		border: '1px solid rgba(0, 0, 0, 0.06)',
	},
	summaryRepeatEnabledContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: '16px',
	},
	summaryPaymentInfoIcon: {
		width: '32px',
		height: '32px',
		marginRight: '16px',
	},
	summaryPaymentInfoContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	totalAmountWrapper: {
		paddingTop: 5,
		'& > p': {
			lineHeight: '20px',
		},
	},
});

export default summaryTabStyle;
